import * as Yup from "yup";

export interface IExtendTrialFormValues {
  days: string;
  reason: string;
}

export const extendTrialValidationSchema = Yup.object().shape({
  days: Yup.string()
    .required("Days to extend is required")
    .test("is-number", "Days must be a valid number", (value) => {
      if (!value) return false;
      const num = Number.parseInt(value, 10);
      return !isNaN(num) && num > 0;
    })
    .test("max-days", "Maximum trial duration is 45 days", (value) => {
      if (!value) return false;
      const num = Number.parseInt(value, 10);
      return !isNaN(num) && num <= 45;
    }),
  reason: Yup.string()
    .required("Reason is required")
    .min(3, "Reason must be at least 3 characters"),
});

export const getExtendTrialFormInitialValues = (): IExtendTrialFormValues => ({
  days: "",
  reason: "",
});

